import { render, staticRenderFns } from "./icon-edit.vue?vue&type=template&id=d15bedbe&"
import script from "./icon-edit.vue?vue&type=script&lang=js&"
export * from "./icon-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports